const EXPIRED_TYPES = {
	BACK_TO_HOTEL: 'back_to_hotel',
	BACK_TO_RESULTS: 'back_to_results',
};

export default {
	EXPIRED_TYPES,
};
